/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { MaterialApi } from "client";
import { useApiWithTimeout } from "./ApiWrapperWithTimeout";
import { useCallApi } from "./CallApiHook";
import { useUserContext } from "context/UserContext";
import { Const } from "const";

export interface MaterialItem {
  id: string;
  type: number;
  name: string;
}
export const useMaterials = () => {
  const [api, canceler] = useApiWithTimeout(
    MaterialApi,
    Const.operationTimeout.getMaterials
  );
  const { jobsite } = useUserContext();
  return useCallApi<MaterialItem[]>(
    async () => {
      console.debug("useMaterials");
      if (jobsite?.jobSiteId === undefined) {
        return [];
      }
      // Retrieve materials
      const response = await api.getMaterialInfo({
        jobsiteId: jobsite.jobSiteId,
      });
      return (
        response.materialInfos?.map((material) => {
          return {
            id: material.materialId,
            type: material.materialType,
            name: material.materialName,
          } as MaterialItem;
        }) ?? []
      );
    },
    canceler,
    [jobsite?.jobSiteId, api, canceler]
  );
};
